import { SlotSelection } from "components/slot-selection/slot-selection";
import useEligibleSlotSelection from "hooks/pages/use-eligible-slot-selection/use-eligible-slot-selection";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";

const ClassSlotSelection = (): JSX.Element | null => {
  const router = useRouter();
  const { query } = router;
  const { userSubscriptionId } = query;

  const {
    isEligibleSlotSelection,
    eligibility,
    isEligibleToSkipSlotSelection,
    isLoading
  } = useEligibleSlotSelection();

  useEffect(() => {
    if (!isLoading && eligibility) {
      if (
        !isEligibleSlotSelection &&
        !eligibility?.courseIds?.length &&
        eligibility?.userSubscriptionId !== userSubscriptionId
      ) {
        router.push("/bimbel/user");
      }
    }
  }, [isEligibleSlotSelection, eligibility, isLoading]);

  const renderContent = () => {
    if (!isLoading) {
      return <SlotSelection isEligibleToSkip={isEligibleToSkipSlotSelection} />;
    }
  };

  return (
    <>
      <Head>
        <title>Pilih Jadwal | CoLearn</title>
      </Head>
      {renderContent()}
    </>
  );
};

export default ClassSlotSelection;

ClassSlotSelection.requireAuth = true;
